"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.debug = exports.explodeRoleId = exports.getRoleId = void 0;
const debug_1 = __importDefault(require("debug"));
const getRoleId = ({ orgId, slug }) => [orgId, slug].join(':');
exports.getRoleId = getRoleId;
const explodeRoleId = (roleId) => {
    const [orgId, slug] = roleId.split(':');
    return { orgId, slug };
};
exports.explodeRoleId = explodeRoleId;
exports.debug = debug_1.default('permissions');
//# sourceMappingURL=utils.js.map